import { render, staticRenderFns } from "./trading-card.vue?vue&type=template&id=3499e93f&scoped=true"
import script from "./trading-card.vue?vue&type=script&lang=js"
export * from "./trading-card.vue?vue&type=script&lang=js"
import style0 from "./trading-card.vue?vue&type=style&index=0&id=3499e93f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3499e93f",
  null
  
)

export default component.exports